import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

const imageUrlMap: Record<string, string> = {
  'article-baisi-origin': 'https://readdy.ai/api/search-image?query=Elegant%20white%20stockings%20fashion%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20style%2C%20clean%20cream%20background%2C%20artistic%20composition%2C%20delicate%20texture%2C%20fashion%20editorial%20aesthetic%2C%20warm%20neutral%20tones&width=800&height=500&seq=article-baisi-origin&orientation=landscape',
  'article-baisi-anime': 'https://readdy.ai/api/search-image?query=Anime%20inspired%20white%20stockings%20character%20design%20with%20soft%20pastel%20colors%2C%20illustration%20style%2C%20clean%20composition%2C%20delicate%20lighting%2C%20artistic%20portrait%2C%20dreamy%20atmosphere&width=800&height=500&seq=article-baisi-anime&orientation=landscape',
  'article-baisi-global': 'https://readdy.ai/api/search-image?query=Global%20fashion%20trend%20white%20stockings%20street%20style%20photography%2C%20modern%20urban%20setting%2C%20diverse%20models%2C%20natural%20light%2C%20editorial%20quality%2C%20clean%20aesthetic&width=800&height=500&seq=article-baisi-global&orientation=landscape',
  'article-baisi-jk': 'https://readdy.ai/api/search-image?query=Japanese%20school%20uniform%20style%20with%20white%20knee%20high%20socks%2C%20academy%20aesthetic%2C%20clean%20minimalist%20photography%2C%20soft%20daylight%2C%20fresh%20youthful%20vibe&width=800&height=500&seq=article-baisi-jk&orientation=landscape',
  'article-baisi-lolita': 'https://readdy.ai/api/search-image?query=Lolita%20fashion%20style%20with%20white%20lace%20stockings%2C%20elegant%20dress%2C%20vintage%20tea%20party%20setting%2C%20soft%20romantic%20lighting%2C%20delicate%20details%2C%20artistic%20photography&width=800&height=500&seq=article-baisi-lolita&orientation=landscape',
  'article-baisi-seasons': 'https://readdy.ai/api/search-image?query=Four%20seasons%20white%20stockings%20fashion%20outfit%20collage%2C%20seasonal%20style%20variations%2C%20clean%20minimal%20photography%2C%20natural%20lighting%2C%20editorial%20aesthetic&width=800&height=500&seq=article-baisi-seasons&orientation=landscape',
  'article-baisi-commute': 'https://readdy.ai/api/search-image?query=Professional%20office%20lady%20wearing%20white%20stockings%20commute%20style%2C%20business%20casual%20outfit%2C%20modern%20city%20background%2C%20clean%20photography%2C%20natural%20light&width=800&height=500&seq=article-baisi-commute&orientation=landscape',
  'article-baisi-choose': 'https://readdy.ai/api/search-image?query=Various%20white%20stockings%20displayed%20on%20minimalist%20surface%2C%20product%20photography%20style%2C%20different%20textures%20and%20materials%2C%20clean%20cream%20background%2C%20soft%20studio%20lighting&width=800&height=500&seq=article-baisi-choose&orientation=landscape',
  'article-baisi-material': 'https://readdy.ai/api/search-image?query=White%20stockings%20fabric%20texture%20closeup%20photography%2C%20silk%20cotton%20nylon%20material%20comparison%2C%20minimalist%20flat%20lay%2C%20clean%20composition%2C%20soft%20lighting&width=800&height=500&seq=article-baisi-material&orientation=landscape',
  'article-baisi-brand': 'https://readdy.ai/api/search-image?query=Luxury%20white%20stockings%20brand%20packaging%20display%2C%20elegant%20product%20photography%2C%20minimalist%20setup%2C%20clean%20cream%20background%2C%20soft%20studio%20light%2C%20premium%20aesthetic&width=800&height=500&seq=article-baisi-brand&orientation=landscape',
  'article-baisi-photography': 'https://readdy.ai/api/search-image?query=Artistic%20white%20stockings%20photography%20with%20dramatic%20lighting%2C%20shadow%20and%20light%20play%2C%20creative%20composition%2C%20fine%20art%20style%2C%20minimalist%20studio%20setup&width=800&height=500&seq=article-baisi-photography&orientation=landscape',
  'article-baisi-oriental': 'https://readdy.ai/api/search-image?query=Oriental%20aesthetic%20white%20silk%20stockings%20with%20traditional%20Chinese%20elements%2C%20ink%20wash%20painting%20style%2C%20elegant%20composition%2C%20soft%20natural%20light%2C%20artistic%20photography&width=800&height=500&seq=article-baisi-oriental&orientation=landscape',
};

const categoryMap: Record<string, string> = {
  'baisi-culture': '白丝文化',
  'trend-outfit': '潮流穿搭',
  'buying-guide': '选购指南',
  'baisi-aesthetic': '白丝美学',
};

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'featured' | 'compact';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  const imageUrl = imageUrlMap[article.imageSeq] || imageUrlMap['article-baisi-origin'];

  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="relative h-64 lg:h-full overflow-hidden">
            <img
              src={imageUrl}
              alt={article.title}
              title={`${article.title} - 白丝文化指南`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="p-6 md:p-8 flex flex-col justify-center">
            <span className="inline-block px-2.5 py-1 text-xs bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
              {categoryMap[article.category]}
            </span>
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
              {article.title}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
              {article.excerpt}
            </p>
            <div className="flex items-center text-xs text-foreground-500 space-x-4">
              <span className="flex items-center">
                <i className="ri-calendar-line mr-1"></i>
                {article.date}
              </span>
              <span className="flex items-center">
                <i className="ri-time-line mr-1"></i>
                {article.readTime}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group flex items-start space-x-4 p-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
      >
        <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
          <img
            src={imageUrl}
            alt={article.title}
            title={`${article.title} - 白丝文化指南`}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-1">
            {article.title}
          </h4>
          <div className="flex items-center text-xs text-foreground-500 space-x-3">
            <span>{article.date}</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={imageUrl}
          alt={article.title}
          title={`${article.title} - 白丝文化指南`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 text-xs bg-background-50/90 text-foreground-800 rounded-full whitespace-nowrap">
            {categoryMap[article.category]}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center text-xs text-foreground-500 space-x-4">
          <span className="flex items-center">
            <i className="ri-calendar-line mr-1"></i>
            {article.date}
          </span>
          <span className="flex items-center">
            <i className="ri-time-line mr-1"></i>
            {article.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}